/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorization-dialog.vue?vue&type=template&id=7fe544a8&scoped=true&"
import script from "./authorization-dialog.vue?vue&type=script&lang=ts&"
export * from "./authorization-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe544a8",
  null
  
)

export default component.exports